import { Component} from '@angular/core';
import { ConfigService } from './shared'

@Component({
    selector: 'dataflowkit',
    template: require('./app.component.html'),
    styles: [require('./app.component.scss')],
    providers: [ConfigService]
})

export class AppComponent {
    constructor(private configService: ConfigService) {}
 }
